import { getDocumentMeta } from 'remote-com-shared/domains/navigation/hrefResolver';

import { getSlicesContext } from '@/src/domains/prismic/helpers';
import { querySharedServices } from '@/src/domains/shared/services';
import {
  queryCountryContractorManagementPage,
  queryAllCountryContractorManagementPages,
} from '@/src/views/Services/ContractorManagement/country/services';

export { CountryContractorManagementPage as default } from '@/src/views/Services/ContractorManagement/country';

export async function getStaticProps({ params, previewData, locale }) {
  const { uid } = params;
  const dataContent = await queryCountryContractorManagementPage({ uid, previewData, locale });

  if (!dataContent) {
    return { notFound: true };
  }

  const sharedServices = await querySharedServices({ previewData, locale });

  const body = await getSlicesContext(dataContent.body, {
    faqs: async () => ({
      dataContent,
    }),
  });

  return {
    props: {
      ...dataContent,
      sharedServices,
      body,
    },
  };
}

/**
 * For dynamic routes with i18n
 * See https://nextjs.org/docs/advanced-features/i18n-routing#dynamic-routes-and-getstaticprops-pages
 */
export async function getStaticPaths() {
  const countryContractorManagemenList = await queryAllCountryContractorManagementPages();
  return {
    paths:
      countryContractorManagemenList?.map((document) => {
        const { uid, lang } = getDocumentMeta(document);
        return {
          params: { uid },
          locale: lang,
        };
      }) || [],
    fallback: false,
  };
}
